import { Breadcrumb, Button, notification, Typography } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { translation } from "../../../../i18n/translationConstant";
import { SelectedAccounts } from "../../../../Models/Request/Account/AccountLink";
import LinkedDelinkedAccountResponse, {
  LinkedDelinkedAccountObject,
} from "../../../../Models/Response/Account/LinkedDelinkedAccounts";
import { GetConsentByIdResponse } from "../../../../Models/Response/Consent/GetConsentById";
import { UserRespose } from "../../../../redux/Reducer/userReducer";
import { getLinkedAccountsOfUser } from "../../../../Services/AccountsServices/AccountService";
import {
  consentApprovalInitiation,
  consentApprove,
  getConsentByConsentHandle,
  getConsentByConsentId,
  getPaginatedConsentByConsentHandle,
  getPaginatedConsentByConsentId,
  updateConsentStatus,
  updateConsentStatusVerification,
} from "../../../../Services/ConsentServices/ConsentService";
import { encode } from "../../../../Services/RedirectionServices/Redirection";
import { authType } from "../../../../Utils/Constants/authType";
import {
  ConsentApprovalStatusType,
  ConsentStatusType,
} from "../../../../Utils/Constants/consentTypes";
import {
  AcitivityTypes,
  QueryParams,
  Routes,
} from "../../../../Utils/Constants/routes";
import ConsentStatusApproval from "../../../Consent/Components/StatusApproval";
import { RootContext } from "../../../Root";
import CommonConsentDetails from "../CommonConsentDetails";
import ConsentByStatus from "../CosentsByType";
import PendingConsent from "../CosentsByType/PendingConsent";
import "./index.css";
import { useLocation } from "react-router-dom";


interface IConsentDetailsProps {
  consentUniqueId: string;
  type: string;
  user: UserRespose;
}

const ConsentDetails: React.FC<IConsentDetailsProps> = ({
  type,
  consentUniqueId,
}) => {
  const { t } = useTranslation();
  const { push, replace } = useHistory();
  const [selectedCard, setSelectedCard] = useState(new Array<string>());
  const [isVerificationModal, setIsVerificationModal] = useState(false);
  const [radioSelect, setRadioSelect] = useState(0);
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const [statusType, setStatusType] = useState("");
  const [otpUniqueID, setOTPUniqueId] = useState("");
  const [linkedAccounts, setLinkedAccounts] = useState(
    new Array<LinkedDelinkedAccountObject>()
  );

  const [pinModalVisible, setPinModalVisible] = useState(false);

  const [consentDetailsById, setConsentDetailsById] = useState({
    Customer: { id: "" },
    DataConsumer: { dataConsumerType: "", id: "" },
    DataFilter: [{ type: "", operator: "", value: "" }],
    DataLife: { unit: "", value: 0 },
    FIDataRange: { from: "", to: "" },
    Frequency: { unit: "", value: 0 },
    Purpose: { category: { type: "" }, code: "", refUri: "", text: "" },
    consentExpiry: "",
    consentMode: "",
    consentStart: "",
    consentTypes: [""],
    ConsentHandle: "",
    fetchType: "",
    fiTypes: [""],
    DataProvider: { id: "", type: "" },
    Accounts: [
      {
        fiType: "",
        fipId: "",
        fipName: "",
        accType: "",
        linkRefNumber: "",
        maskedAccNumber: "",
        logoUrl: "",
      },
    ],
  });

  const [consentCardDetail, setConsetCardDetail] = useState({
    consentid: "",
    version: "",
    fiuId: "",
    fiuName: "",
    vuaId: "",
    consentHandle: "",
    consentStatusType: "",
    consentApprovalStatusType: "",
    usedCount: "",
    lastusedAt: "",
    createdOn: "",
    updatedOn: "",
    logoUrl: "",
    purpose: "",
    consentExpiry: "",
  });

  const [approvalStatus, setApprovalStatus] = useState("");

  const { setHeader }: any = useContext(RootContext);
  
  const location = useLocation<{ from?: string }>();
  const history = useHistory();

  useEffect(() => {
    if (type === ConsentApprovalStatusType.PENDING) {
      getLinkedAccountsOfUser()
        .then((res) => res.data)
        .then((res: LinkedDelinkedAccountResponse) => {
          setLinkedAccounts(res);

        const cameFromLinkAccounts = location.state?.from === Routes.linkAccounts;
        const alreadyRedirected = sessionStorage.getItem("redirectedToLinkAccounts");

        if (
          res.length === 0 &&
          location.pathname !== Routes.linkAccounts &&
          !cameFromLinkAccounts &&
          !alreadyRedirected
        ) {
          sessionStorage.setItem("redirectedToLinkAccounts", "true");
          history.push({
            pathname: Routes.linkAccounts,
            state: { from: location.pathname },
          });
        }
      });
  }
}, [type, location.pathname, history]);


//   //If linked accounts are not present, redirect to add accounts.
//   const [redirected, setRedirected] = useState(false);
//   useEffect(() => {
//   if (linkedAccounts.length === 0 && !redirected) {
//     setRedirected(true);

//     history.push(Routes.linkAccounts, {
//       from: location.pathname,   // pass current path as `from`
//     });
//   }
// }, [linkedAccounts, redirected, location.pathname, history]);

  const [loadPending, setLoadPending] = useState(false);

  const goBack = useCallback(() => {
    push(Routes.consent);
  }, [push]);

  const pushToHistory = useCallback(() => {
    push({
      pathname: Routes.more + Routes.history,
      search: `?${QueryParams.entityId}=${consentDetailsById.ConsentHandle}&${QueryParams.entityType}=${AcitivityTypes.consent}`,
    });
  }, [push, consentDetailsById.ConsentHandle]);

  useEffect(() => {
    setHeader(
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Breadcrumb className="breadCrumbs" separator=">">
          <Breadcrumb.Item onClick={goBack}>{t("Home")}</Breadcrumb.Item>
          <Breadcrumb.Item>
            {consentDetailsById.DataConsumer.id}
          </Breadcrumb.Item>
        </Breadcrumb>
        <Button
          style={{ fontSize: 18, fontWeight: 500, color: "#E36D2C" }}
          type="text"
          onClick={pushToHistory}
        >
          {t("lblHistory")}
        </Button>
      </div>
    );
    return () => {
      setHeader(null);
    };
  }, [consentDetailsById.DataConsumer.id, goBack, setHeader, pushToHistory, t]);


  useEffect(() => {
    const temp = linkedAccounts.filter((item) => {
      if (consentDetailsById.fiTypes.includes(item.fiType)) {
        return item;
      }
    });
    setLinkedAccounts(temp);
  }, [consentDetailsById.fiTypes]);


  const cardClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (selectedCard.indexOf(event.currentTarget.id) === -1) {
      setSelectedCard([...selectedCard, event.currentTarget.id]);
    } else {
      setSelectedCard(
        selectedCard.filter((card) => card !== event.currentTarget.id)
      );
    }
  };


  // const approvalConsent = (consentApprovalType: string) => {
  // //   setIsVerificationModal(true);
  // //   setApprovalStatus(consentApprovalType);

  //   // Directly trigger OTP flow for both Accept and Reject
  //   setRadioSelect(1);
  //   consentApprovalInitiation(consentUniqueId, consentApprovalType)
  //     .then((res) => res.data)
  //     .then((res) => {
  //       setApprovalStatus(consentApprovalType); // store status
  //       setOTPUniqueId(res.otpUniqueID);       // OTP ID returned from backend
  //       setIsOtpModalVisible(true);            // Show OTP modal directly
  //       setIsVerificationModal(false);         // Hide the old selection modal
  //       setPinModalVisible(false);             // Hide PIN modal if open
  //     });
  // };

  const approvalConsent = (consentApprovalType: string) => {
    setApprovalStatus(consentApprovalType);

    consentApprove({
      consentHandle: consentUniqueId,
      constentApprovalStatus:
        localStorage.getItem("isV1") === "true"
          ? consentApprovalType
          : consentApprovalType == "READY"
          ? "APPROVED"
          : consentApprovalType == "FAILED"
          ? "REJECTED"
          : consentApprovalType,
      authType: authType.NONE,  
      authValue: "",
      accounts: mapToLinkedRefNumberAndFIPHandle(),
      otpUniqueID: otpUniqueID,
    }).then((value) => {
      consentApprovalType ===
      (localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED")
        ? notification.error({ message: t(translation.lblConsentRejected) })
        : value.data.ConsentStatus ===
          (localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED")
        ? notification.error({ message: t(translation.lblConsentRejected) })
        : notification.success({ message: t(translation.lblConsentApproved) });

      const conHandle = localStorage.getItem("srcref");
      if (!!conHandle && conHandle === consentUniqueId) {
        if (
          consentApprovalType ===
          (localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED")
        ) {
          redirect("F", "1");
        } else {
          redirect("S", "0");
        }
      } else {
        push("/consent");
      }
    });
  };

  const radioSelectEvent = (e: number) => setRadioSelect(e);

  const closeModal = () => {
    setIsVerificationModal(false);
  };

  const redirect = (status: string, errorcode: string) => {
    if (
      !!localStorage.getItem("redirect") &&
      !!localStorage.getItem("txnid") &&
      !!localStorage.getItem("sessionid")
    ) {
      const encodeParam = {
        status,
        errorcode,
        txnid: localStorage.getItem("txnid") || "",
        sessionid: localStorage.getItem("sessionid") || "",
        srcref: localStorage.getItem("srcref") || "",
        userid: localStorage.getItem("userid") || "",
      };

      encode(encodeParam).then((res) => {
        window.location.replace(
          `${localStorage.getItem("redirect")}?fi=${res.data.fi}&resdate=${res.data.resdate
          }&ecres=${res.data.ecres}`
        );
        localStorage.clear();
      });
    } else {
      push("/consent");
    }
  };

  const mapToLinkedRefNumberAndFIPHandle = () => {
    const accounts: SelectedAccounts[] = linkedAccounts
      .filter((_account, index) => {
        console.log("account ", _account);
        return selectedCard.indexOf(index.toString()) !== -1;
      })
      .map((account) => {
        return {
          linkRefNumber: account.linkRefNumber,
          fipHandle: account.fipHandle,
        };
      });
    return accounts;
  };

  const onSelectionModal = () => {
    if (type === ConsentApprovalStatusType.PENDING) {
      if (radioSelect === 0) {
        setPinModalVisible(true);
        setIsVerificationModal(false);
      } else {
        consentApprovalInitiation(consentUniqueId, approvalStatus)
          .then((res) => res.data)
          .then((res) => {
            setIsOtpModalVisible(true);
            setIsVerificationModal(false);
            setOTPUniqueId(res.otpUniqueID);
          });
      }
    } else {
      if (radioSelect === 0) {
        setPinModalVisible(true);
        setIsVerificationModal(false);
      } else {
        updateConsentStatus(consentUniqueId, statusType)
          .then((res) => res.data)
          .then((res) => {
            setIsOtpModalVisible(true);
            setIsVerificationModal(false);
            setOTPUniqueId(res.otpUniqueID);
          });
      }
    }
  };

  // const updateConsentByStatus = (updateStatusType: string) => {
  //   setIsVerificationModal(true);
  //   setStatusType(updateStatusType);
  // };

  const updateConsentByStatus = (updateStatusType: string) => {

    updateConsentStatusVerification({
      consentId: consentUniqueId,
      consentStatus: updateStatusType,
      authType: authType.NONE,
      authValue: "",
    }).then(() => {
      notification.success({
        message: t(translation.lblConsentStatusChange),
      });
      setIsVerificationModal(false);
      push(Routes.consent);
    });
  };

  const verifyOTPAuth = (otp: string) => {
    if (type === ConsentApprovalStatusType.PENDING) {
      if (radioSelect === 0) {
        consentApprove({
          consentHandle: consentUniqueId,
          constentApprovalStatus: localStorage.getItem("isV1") === "true" ? approvalStatus : approvalStatus == "READY" ? "APPROVED" : approvalStatus == "FAILED" ? "REJECTED" : approvalStatus,
          authType: authType.PIN,
          authValue: otp,
          accounts: mapToLinkedRefNumberAndFIPHandle(),
          otpUniqueID,
        }).then((value) => {
          approvalStatus ===
            (localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED")
            ? notification.error({
              message: t(translation.lblConsentRejected),
            })
            : value.data.ConsentStatus ===
              (localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED")
              ? notification.error({
                message: t(translation.lblConsentRejected),
              })
              : notification.success({
                message: t(translation.lblConsentApproved),
              });

          setIsVerificationModal(false);

          const conHandle = localStorage.getItem("srcref");
          if (!!conHandle && conHandle === consentUniqueId) {
            if (
              approvalStatus ===
              (localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED")
            ) {
              redirect("F", "1");
            } else {
              redirect("S", "0");
            }
          } else {
            push("/consent");
          }
        });
      } else {
        consentApprove({
          consentHandle: consentUniqueId,
          constentApprovalStatus: localStorage.getItem("isV1") === "true" ? approvalStatus : approvalStatus == "READY" ? "APPROVED" : approvalStatus == "FAILED" ? "REJECTED" : approvalStatus,
          authType: authType.OTP,
          authValue: otp,
          accounts: mapToLinkedRefNumberAndFIPHandle(),
          otpUniqueID,
        }).then((value) => {
          approvalStatus ===
            (localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED")
            ? notification.error({ message: t(translation.lblConsentRejected) })
            : value.data.ConsentStatus ===
              (localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED")
              ? notification.error({
                message: t(translation.lblConsentRejected),
              })
              : notification.success({
                message: t(translation.lblConsentApproved),
              });
          setIsOtpModalVisible(false);

          const conHandle = localStorage.getItem("srcref");
          if (!!conHandle && conHandle === consentUniqueId) {
            if (
              approvalStatus ===
              (localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED")
            ) {
              redirect("F", "1");
            } else {
              redirect("S", "0");
            }
          } else {
            push("/consent");
          }
        });
      }
    } else {
      if (radioSelect === 0) {
        updateConsentStatusVerification({
          consentId: consentUniqueId,
          consentStatus: statusType,
          authType: authType.PIN,
          authValue: otp,
        }).then(() => {
          notification.success({
            message: t(translation.lblConsentStatusChange),
          });
          setIsVerificationModal(false);
          push(Routes.consent);
        });
      } else {
        updateConsentStatusVerification({
          consentId: consentUniqueId,
          consentStatus: statusType,
          authType: authType.OTP,
          authValue: otp,
          otpUniqueID,
        }).then(() => {
          notification.success({
            message: t(translation.lblConsentStatusChange),
          });
          setIsOtpModalVisible(false);
          push(Routes.consent);
        });
      }
    }
  };

  const onClose = () => {
    setIsOtpModalVisible(false);
    setPinModalVisible(false);
  };

  useEffect(() => {
    if (
      type === ConsentStatusType.REJECTED ||
      type === ConsentStatusType.EXPIRED ||
      type === ConsentApprovalStatusType.PENDING
    ) {
      getPaginatedConsentByConsentHandle(consentUniqueId)
        .then((res) => res.data)
        .then((res: any) => {
          if (!!res && !!res.content && res.content.length >= 1) {
            setConsetCardDetail(res.content[0]);
          }
        });

      getConsentByConsentHandle(consentUniqueId)
        .then((res) => res.data)
        .then((res: GetConsentByIdResponse) => setConsentDetailsById(res))
        .catch(() => {
          if (
            !!localStorage.getItem("redirect") &&
            !!localStorage.getItem("txnid") &&
            !!localStorage.getItem("sessionid")
          ) {
            const encodeParam = {
              txnid: localStorage.getItem("txnid") || "",
              sessionid: localStorage.getItem("sessionid") || "",
              srcref: localStorage.getItem("srcref") || "",
              status: "F",
              errorcode: "2",
              userid: localStorage.getItem("userid") || "",
            };

            encode(encodeParam).then((res) => {
              window.location.replace(
                `${localStorage.getItem("redirect")}?fi=${res.data.fi
                }&resdate=${res.data.resdate}&ecres=${res.data.ecres}`
              );
              localStorage.clear();
            });
          }
          replace(Routes.consent);
        });
    } else {
      getPaginatedConsentByConsentId(consentUniqueId)
        .then((res) => res.data)
        .then((res: any) => {
          if (!!res && !!res.content && res.content.length >= 1) {
            setConsetCardDetail(res.content[0]);
          }
        });
      getConsentByConsentId(consentUniqueId)
        .then((res) => res.data)
        .then((res: GetConsentByIdResponse) => setConsentDetailsById(res));
    }
  }, [consentUniqueId, type, replace]);


  return (
    <>
      <ConsentStatusApproval
        typeOfModal={approvalStatus ? approvalStatus : statusType}
        isAuthTypeSelectionModalVisible={isVerificationModal}
        onCloseAuthTypeSelectionModal={closeModal}
        onAuthTypeModalSubmit={onSelectionModal}
        onAuthTypeRadioSelectionChange={radioSelectEvent}
        selectedAuthType={radioSelect}
        verifyOTPAuthType={verifyOTPAuth}
        isAuthTypeOTPModalVisible={isOtpModalVisible}
        onCloseOTPModal={onClose}
        pinModalVisible={pinModalVisible}
      />

      <div className="consentDetailsRoot">
        <CommonConsentDetails
          consentByUniqueIdDetails={consentDetailsById}
          state={consentCardDetail}
        />

        <Typography.Text className="consentDetailsAccountTypo">
          {type === ConsentApprovalStatusType.PENDING ? (
            t(translation.lblSelectAccountForSharingInfo)
          ) : type !== ConsentStatusType.REJECTED &&
            type !== ConsentStatusType.EXPIRED ? (
            t(translation.lblLinkedAccounts)
          ) : (
            <></>
          )}
        </Typography.Text>

        <span className="divider">|</span>
       
        <Link to={{
            pathname: Routes.linkAccounts,
            state: {from: location.pathname}
          }}>
            <strong>ADD NEW</strong>
        </Link>

        {type === ConsentApprovalStatusType.PENDING ? (
          <PendingConsent
            selectedCard={selectedCard}
            linkedAccounts={linkedAccounts}
            cardClick={cardClick}
            approvalConsent={approvalConsent}
          />
        ) : type !== ConsentStatusType.REJECTED &&
          type !== ConsentStatusType.EXPIRED ? (
          <ConsentByStatus
            consentDetailsById={consentDetailsById}
            type={type}
            onConsentStatusUpdate={updateConsentByStatus}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default ConsentDetails;
